module.exports = __webpack_public_path__ + "img/img20.a1d501cd.png";